import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Barefoot running",
  "description": "",
  "published": "2010-07-06T00:00:00.000Z",
  "redirect_from": ["/blog/barefoot-running/swizec/1374"],
  "categories": "Athletic, barefoot, Footwear, Leather, life, Shoe, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/File:Bust_shot_leather_art.jpeg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/07/300px-Bust_shot_leather_art.jpeg",
              "alt": "Handmade leather art",
              "title": "Handmade leather art"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/File:Bust_shot_leather_art.jpeg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`The story begins with a young boy who had a pair of shoes he loved very much. They were the bestest and most durablest pair of shoes he ever did own.`}</p>
    <p>{`And they were pretty too! My god, all the female shoes turned their heads as they walked by. The shoes were sporting a lovely black leather body with a red line or two in strategic places, topped off by a magnificent red Fallen logo. The shoe laces were knotted off at the base and survived most of their time being stunk up and walked upon by dirty socks as was the fashion of the time.`}</p>
    <p>{`The shoes lived life together with the boy through all sorts of haps and mishaps. They were there when he got drunk, they were there when he decided it might be a good thing to do some sporty things like running and stuff. They bared it all!`}</p>
    <p>{`Resilient little shoes that they were.`}</p>
    <p>{`There were times when younger, more sexier shoes, almost took their place in the boy's life. But it never happened, somehow, through some turn of fortune, they always came back to embrace the boy's feet and make the nasty experience of walking all lovely and comfortable and just like he was floating about on a cushion of air.`}</p>
    <p>{`But despite all, they were getting old.`}</p>
    <p>{`There were giant holes gaping from pretty much everywhere. Their posterior was old and battered and nearly mashed up and eaten through like a pack of rabid wolves got their hands on them. Almost every time they made a step they tore through the boy's socks in an act of defiance as if to scream "HEY I'M FUCKING OLD! I DON'T LIKE WALKING ANYMORE LEAVE ME ALONE!"`}</p>
    <p>{`And the boy heeded their call and he did decide to buy a new pair very soon. But his mother heard them even more so one day she up and threw them in the trash. Alas, the boy now had not a shoe to put on his feet.`}</p>
    <p>{`He decided to go for a run despite all. Do it barefoot so to speak.`}</p>
    <p>{`Now his soles are kind of tender.`}</p>
    <p>{`The end.`}</p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://seattletimes.nwsource.com/html/health/2012236317_barefoot02.html?syndication=rss"
        }}>{`Barefoot running gains a following`}</a>{` (seattletimes.nwsource.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.wired.com/geekdad/2010/06/vivo-barefoot-shoes-now-for-kids/"
        }}>{`Vivo Barefoot Shoes, Now for Kids`}</a>{` (wired.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://walking-running-training.suite101.com/article.cfm/how-to-transition-from-running-shoes-to-barefoot-running"
        }}>{`How to Transition from Running Shoes to Barefoot Running`}</a>{` (walking-running-training.suite101.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://seattletimes.nwsource.com/html/health/2012287080_shoeshealth06.html?syndication=rss"
        }}>{`5 shoes to rock your world`}</a>{` (seattletimes.nwsource.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.atomiurl.com/are-shoes-that-simulate-walking-barefoot-better"
        }}>{`Are Shoes That Simulate Walking Barefoot Better?`}</a>{` (atomiurl.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.runblogger.com/2010/06/barefoot-running-baby-forefoot-steps-in.html"
        }}>{`Barefoot Running - Baby (Forefoot) Steps in the Right Direction on Run #3`}</a>{` (runblogger.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7eed4716-4cd2-4eb7-94b3-ffbec15314ed",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      